import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Curriculum.css';

const Curriculum = () => {
  const [activeTab, setActiveTab] = useState('demo');
  const [activeLittleModule, setActiveLittleModule] = useState(null);
  const [activeJuniorModule, setActiveJuniorModule] = useState(null);
  const [demoCourses, setDemoCourses] = useState({ little: [], junior: [] });
  const [littleModules, setLittleModules] = useState([]);
  const [juniorModules, setJuniorModules] = useState([]);
  const [littleCourses, setLittleCourses] = useState([]);
  const [juniorCourses, setJuniorCourses] = useState([]);
  const [loading, setLoading] = useState({
    demo: false,
    littleModules: false,
    juniorModules: false,
    littleCourses: false,
    juniorCourses: false
  });
  const [error, setError] = useState(null);

  // Fetch demo sessions
  useEffect(() => {
    if (activeTab === 'demo' && demoCourses.little.length === 0 && demoCourses.junior.length === 0) {
      fetchDemoSessions();
    }
  }, [activeTab, demoCourses]);

  // Fetch little modules when tab changes to little
  useEffect(() => {
    if (activeTab === 'little' && littleModules.length === 0) {
      fetchLittleModules();
    }
  }, [activeTab, littleModules]);

  // Fetch junior modules when tab changes to junior
  useEffect(() => {
    if (activeTab === 'junior' && juniorModules.length === 0) {
      fetchJuniorModules();
    }
  }, [activeTab, juniorModules]);

  // Fetch little courses when module is selected
  useEffect(() => {
    if (activeTab === 'little' && activeLittleModule) {
      fetchLittleCourses(activeLittleModule);
    }
  }, [activeTab, activeLittleModule]);

  // Fetch junior courses when module is selected
  useEffect(() => {
    if (activeTab === 'junior' && activeJuniorModule) {
      fetchJuniorCourses(activeJuniorModule);
    }
  }, [activeTab, activeJuniorModule]);

  const fetchDemoSessions = async () => {
    try {
      setLoading(prev => ({ ...prev, demo: true }));
      setError(null);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teacher/Curriculum/demo`);
      
      // Separate into little (Plan 1) and junior (Plan 2)
      const little = response.data.filter(item => item.Plan === 1);
      const junior = response.data.filter(item => item.Plan === 2);
      
      setDemoCourses({
        little: little.map(item => ({
          id: item.Id,
          name: item.ProjectName,
          image: item.ImgLink,
          details: item.ProjectDetails,
          link: item.ProjectLink,
          ageRange: item.AgeDetails,
          gradeRange: item.GradeDetails
        })),
        junior: junior.map(item => ({
          id: item.Id,
          name: item.ProjectName,
          image: item.ImgLink,
          details: item.ProjectDetails,
          link: item.ProjectLink,
          ageRange: item.AgeDetails,
          gradeRange: item.GradeDetails
        }))
      });
    } catch (err) {
      setError('Failed to fetch demo sessions. Please try again later.');
      console.error('Error fetching demo sessions:', err);
    } finally {
      setLoading(prev => ({ ...prev, demo: false }));
    }
  };

  const fetchLittleModules = async () => {
    try {
      setLoading(prev => ({ ...prev, littleModules: true }));
      setError(null);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teacher/Curriculum/modules/1`);
      setLittleModules(response.data.map(module => ({
        id: module.Id,
        name: `${module.ModuleName}`
      })));
    } catch (err) {
      setError('Failed to fetch little modules. Please try again later.');
      console.error('Error fetching little modules:', err);
    } finally {
      setLoading(prev => ({ ...prev, littleModules: false }));
    }
  };

  const fetchJuniorModules = async () => {
    try {
      setLoading(prev => ({ ...prev, juniorModules: true }));
      setError(null);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teacher/Curriculum/modules/2`);
      setJuniorModules(response.data.map(module => ({
        id: module.Id,
        name: `${module.ModuleName}`
      })));
    } catch (err) {
      setError('Failed to fetch junior modules. Please try again later.');
      console.error('Error fetching junior modules:', err);
    } finally {
      setLoading(prev => ({ ...prev, juniorModules: false }));
    }
  };

  const fetchLittleCourses = async (moduleId) => {
    try {
      setLoading(prev => ({ ...prev, littleCourses: true }));
      setError(null);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teacher/Curriculum/paid/${moduleId}/1`);
      setLittleCourses(response.data.courses.map(course => ({
        id: course.Id,
        name: course.CourseName,
        image: course.CourseFilesLink,
        link: course.CourseLink,
        ppt: course.CourseProjectLink,
        note: course.CourseNote,
        assignment: course.CourseAssignmentLink
      })));
    } catch (err) {
      setError('Failed to fetch little courses. Please try again later.');
      console.error('Error fetching little courses:', err);
    } finally {
      setLoading(prev => ({ ...prev, littleCourses: false }));
    }
  };

  const fetchJuniorCourses = async (moduleId) => {
    try {
      setLoading(prev => ({ ...prev, juniorCourses: true }));
      setError(null);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teacher/Curriculum/paid/${moduleId}/2`);
      setJuniorCourses(response.data.courses.map(course => ({
        id: course.Id,
        name: course.CourseName,
        image: course.CourseFilesLink,
        link: course.CourseLink,
        ppt: course.CourseProjectLink,
        note: course.CourseNote,
        assignment: course.CourseAssignmentLink
      })));
    } catch (err) {
      setError('Failed to fetch junior courses. Please try again later.');
      console.error('Error fetching junior courses:', err);
    } finally {
      setLoading(prev => ({ ...prev, juniorCourses: false }));
    }
  };

  return (
    <div className="cur-container">
       <header className="my-classes__header">
        <div className="my-classes__header-content">
          
          <p className="my-classes__subheader">This is Our Curriculum</p>
        </div>
        
      </header>
      {error && <div className="cur-error">{error}</div>}
      
      {/* Tabs Navigation */}
      <div className="cur-tabs">
        <button 
          className={`cur-tab ${activeTab === 'demo' ? 'active' : ''}`}
          onClick={() => setActiveTab('demo')}
        >
          Demo Sessions
        </button>
        <button 
          className={`cur-tab ${activeTab === 'little' ? 'active' : ''}`}
          onClick={() => setActiveTab('little')}
        >
          Little Course
        </button>
        <button 
          className={`cur-tab ${activeTab === 'junior' ? 'active' : ''}`}
          onClick={() => setActiveTab('junior')}
        >
          Junior Course
        </button>
      </div>
      
      {/* Demo Sessions Tab */}
      {activeTab === 'demo' && (
        <section className="cur-section">
          <h2 className="cur-section-title">Demo Sessions</h2>
          
          {loading.demo ? (
            <div className="cur-loading">Loading demo sessions...</div>
          ) : (
            <div className="cur-demo-grid">
              {/* Little Demo Sessions */}
              <div className="cur-demo-category">
                <h3 className="cur-category-title">Little (Grade 1 - Grade 3)</h3>
                {demoCourses.little.length > 0 && (
                  <p className="cur-age-range">{demoCourses.little[0].ageRange}</p>
                )}
                <div className="cur-demo-cards">
                  {demoCourses.little.map(demo => (
                    <div key={demo.id} className="cur-demo-card">
                      <img src={demo.image} alt={demo.name} className="cur-demo-image" />
                      <div className="cur-demo-content">
                        <h4 className="cur-demo-name">{demo.name}</h4>
                        <p className="cur-demo-details">{demo.details}</p>
                        <a href={demo.link} target="_blank" rel="noopener noreferrer" className="cur-demo-button">
                          View Demo
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Junior Demo Sessions */}
              <div className="cur-demo-category">
                <h3 className="cur-category-title">Junior (Grade 4 - Grade 12)</h3>
                {demoCourses.junior.length > 0 && (
                  <p className="cur-age-range">{demoCourses.junior[0].ageRange}</p>
                )}
                <div className="cur-demo-cards">
                  {demoCourses.junior.map(demo => (
                    <div key={demo.id} className="cur-demo-card">
                      <img src={demo.image} alt={demo.name} className="cur-demo-image" />
                      <div className="cur-demo-content">
                        <h4 className="cur-demo-name">{demo.name}</h4>
                        <p className="cur-demo-details">{demo.details}</p>
                        <a href={demo.link} target="_blank" rel="noopener noreferrer" className="cur-demo-button">
                          View Demo
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </section>
      )}
      
      {/* Little Course Tab */}
      {activeTab === 'little' && (
        <section className="cur-section">
          <h2 className="cur-section-title">Little Course (Grade 1 - Grade 3)</h2>
          
          {loading.littleModules ? (
            <div className="cur-loading">Loading modules...</div>
          ) : (
            <div className="cur-module-selector">
              <select 
                className="cur-module-dropdown"
                onChange={(e) => setActiveLittleModule(e.target.value)}
                value={activeLittleModule || ""}
                disabled={loading.littleModules}
              >
                <option value="">Select a Module</option>
                {littleModules.map(module => (
                  <option key={module.id} value={module.id}>
                    {module.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          
          {loading.littleCourses ? (
            <div className="cur-loading">Loading courses...</div>
          ) : activeLittleModule && littleCourses.length > 0 ? (
            <div className="cur-projects-list">
              {littleCourses.map((course, index) => (
                <div key={course.id} className="cur-project-item">
                  <div className="cur-project-image-container">
                    <img src={course.image} alt={course.name} className="cur-project-image" />
                  </div>
                  <div className="cur-project-details">
                    <h4 className="cur-project-name">Project {index + 1}: {course.name}</h4>
                    <div className="cur-project-buttons">
                      <a 
                        href={course.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="cur-project-button cur-view-button"
                      >
                        View Project
                      </a>
                      <a 
                        href={course.ppt} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="cur-project-button cur-ppt-button"
                      >
                        Check Course
                      </a>
                      
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : activeLittleModule ? (
            <div className="cur-no-courses">No courses found for this module.</div>
          ) : null}
        </section>
      )}
      
      {/* Junior Course Tab */}
      {activeTab === 'junior' && (
        <section className="cur-section">
          <h2 className="cur-section-title">Junior Course (Grade 4 - Grade 12)</h2>
          
          {loading.juniorModules ? (
            <div className="cur-loading">Loading modules...</div>
          ) : (
            <div className="cur-module-selector">
              <select 
                className="cur-module-dropdown"
                onChange={(e) => setActiveJuniorModule(e.target.value)}
                value={activeJuniorModule || ""}
                disabled={loading.juniorModules}
              >
                <option value="">Select a Module</option>
                {juniorModules.map(module => (
                  <option key={module.id} value={module.id}>
                    {module.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          
          {loading.juniorCourses ? (
            <div className="cur-loading">Loading courses...</div>
          ) : activeJuniorModule && juniorCourses.length > 0 ? (
            <div className="cur-projects-list">
              {juniorCourses.map(course => (
                <div key={course.id} className="cur-project-item">
                  <div className="cur-project-image-container">
                    <img src={course.image} alt={course.name} className="cur-project-image" />
                  </div>
                  <div className="cur-project-details">
                    <h4 className="cur-project-name">{course.name}</h4>
                    <div className="cur-project-buttons">
                      <a 
                        href={course.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="cur-project-button cur-view-button"
                      >
                        View Project
                      </a>
                      <a 
                        href={course.ppt} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="cur-project-button cur-ppt-button"
                      >
                        Check Course
                      </a>
                    
                     
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : activeJuniorModule ? (
            <div className="cur-no-courses">No courses found for this module.</div>
          ) : null}
        </section>
      )}
    </div>
  );
};

export default Curriculum;